export const usePageContext = () => {
  const pageContext = sessionStorage.getItem('pageContext')

  const isWebView = pageContext?.toLowerCase().trim() === 'webview'

  return {
    pageContext,
    isWebView,
  }
}
